import React from 'react';
import { useTranslation } from 'react-i18next';
import Popup from '../../ui/popup/Popup';
import MainSquareButton from '../../ui/buttons/MainSquareButton';
import '../../styles/components/sidebar/brandLimitUpgradePopup.scss';

interface BrandLimitUpgradePopupProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

const BrandLimitUpgradePopup = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: BrandLimitUpgradePopupProps) => {
  const { t } = useTranslation();

  return (
    <Popup
      trigger={isOpen}
      setTrigger={onClose}
      styles={{
        maxWidth: '450px',
        width: '90%',
        padding: '2.5rem',
        borderRadius: '16px',
        backgroundColor: 'var(--sidebar-background-color)',
      }}
      isCloseBtnHidden={isLoading}
    >
      <div className='brandLimitUpgradePopup'>
        <div className='brandLimitUpgradePopup__header'>
          <h2>{t('UpgradePlan')}</h2>
        </div>
        
        <div className='brandLimitUpgradePopup__body'>
          <p>
            {t('BrandLimitReachedMessage', {
              defaultValue: "You've reached your brand limit. Do you want to add 5 additional seats?",
            })}
          </p>
        </div>

        <div className='brandLimitUpgradePopup__actions'>
          <button
            className='brandLimitUpgradePopup__cancel-btn'
            onClick={onClose}
            disabled={isLoading}
            type='button'
          >
            {t('Cancel')}
          </button>
          
          <MainSquareButton
            value={t('YesAddSeats', { defaultValue: 'Yes, Add 5 Seats' })}
            onClick={onConfirm}
            loading={isLoading}
            disabled={isLoading}
            normal={true}
            type='button'
          />
        </div>
      </div>
    </Popup>
  );
};

export default BrandLimitUpgradePopup;

